var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconDamage = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M26.4032 17.3517H22.2083L16.019 27.1923H25.3805L24.3727 33.0838L31.8937 24.3782H22.2673L26.4032 17.3517Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9999 0L0.0639648 19.6231L1.84807 21.7993L3.34824 20.5694V48H44.6364V20.5568L46.1519 21.7993L47.936 19.6231L23.9999 0ZM19.8947 42.5716L22.0442 30.0063H10.9248L20.6537 14.5377H31.3249L27.189 21.5642H38.0435L19.8947 42.5716Z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDamage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_damage.65f39b49.svg";
export { ForwardRef as ReactComponent };